const MOBILE_MAX = 1440; // px

function isMobile() { return window.matchMedia(`(max-width:${MOBILE_MAX}px)`).matches; }

function initNav() {
    const nav = document.getElementById('nav-bar');
    if (!nav || nav.dataset.bound) return;
    nav.dataset.bound = '1';

    const burger = nav.querySelector('.nav-toggle-btn');

    burger?.addEventListener('click', () => {
        if (!isMobile()) return; // don't toggle drawer on desktop
        const open = nav.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        document.body.classList.toggle('no-scroll', open);
        if (open) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    });

    // Submenu toggles only on mobile
    nav.addEventListener('click', (e) => {
        const t = e.target.closest('.sub-toggle');
        if (!t || !isMobile()) return;
        e.preventDefault();
        const li = t.closest('.has-children');
        if (!li) return;

        // close siblings (optional, feels nicer)
        li.parentElement.querySelectorAll('.has-children.open').forEach(x => {
            if (x !== li) x.classList.remove('open');
        });
        li.classList.toggle('open');
    });

    // Close drawer on link click (mobile)
    nav.addEventListener('click', (e) => {
        const a = e.target.closest('.menu a');
        if (!a || !isMobile()) return;
        nav.classList.remove('is-open');
        document.body.classList.remove('no-scroll');
        burger?.setAttribute('aria-expanded', 'false');
    });

    // On resize to desktop, clear mobile state
    window.addEventListener('resize', () => {
        if (!isMobile()) {
            nav.classList.remove('is-open');
            document.body.classList.remove('no-scroll');
            nav.querySelectorAll('.has-children.open').forEach(li => li.classList.remove('open'));
            burger?.setAttribute('aria-expanded', 'false');
        }
    });
}
// Close dropdowns + drawer after any nav link click
function closeNavState() {
    const nav = document.getElementById('nav-bar');
    if (!nav) return;
    nav.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
    nav.querySelectorAll('.has-children.open').forEach(li => li.classList.remove('open'));
    // kill :focus-within so desktop dropdown closes
    const active = document.activeElement;
    if (active && active.blur) active.blur();
    // optional: move focus to content for a11y
    const app = document.getElementById('app');
    if (app) { app.setAttribute('tabindex', '-1'); app.focus({ preventScroll: true }); app.removeAttribute('tabindex'); }
}

document.getElementById('nav-bar')?.addEventListener('click', (e) => {
    const a = e.target.closest('.menu a');
    if (!a) return;
    // let your router do its thing, then clear state
    setTimeout(closeNavState, 0);
});

// also after every partial swap
document.addEventListener('partial:loaded', closeNavState);

document.addEventListener('DOMContentLoaded', initNav);
document.addEventListener('partial:loaded', initNav);
